export var MineTypeModel;
(function (MineTypeModel) {
    MineTypeModel["pdf"] = "application/pdf";
    MineTypeModel["xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MineTypeModel["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MineTypeModel["doc"] = "application/msword";
})(MineTypeModel || (MineTypeModel = {}));
